<template>
  <div class="header">
    <div class="left">
      <img class="logo" src="@/assets/img/logo1.png">
    </div>
    <div class="right">
      <van-popover
        v-model:show="showPopover"
        theme="dark"
        :teleport="element"
        :show-arrow="false"
        :actions="actions"
      >
        <template #reference>
          <div class="lang">
            <img class="icon" src="@/assets/img/icon_lang.png">
<!--            <div class="text">中文</div>-->
<!--            <img class="arrow" src="@/assets/img/icon_arrowD.png">-->
          </div>
        </template>
      </van-popover>
      <div class="wallet">
        <img class="icon" src="@/assets/img/icon_wallet.png">
        <div class="text">{{ getEllipsis(address, '***', 3, 3) }}</div>
      </div>
    </div>
  </div>
  <div class="block"></div>

  <!--绑定上级-->
  <van-popup
    v-model:show="show"
    :close-on-click-overlay="false"
  >
    <div class="bind">
      <div class="title">绑定上级</div>
      <textarea v-model="pAddr" rows="2" placeholder="请输入上级地址"></textarea>
      <div class="btn" @click="handleBind">提交</div>
    </div>
  </van-popup>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { getEllipsis } from '@/utils'
  import { showToast, showLoadingToast, showSuccessToast, showFailToast } from 'vant'
  import { useRoute } from "vue-router";

  const Web3Modal = window.Web3Modal.default;
  const WalletConnectProvider = window.WalletConnectProvider.default;

  // Web3modal instance
  let web3Modal, network, provider, selectedAccount, provider1, gasPrice, signer, usdtContract,
  conContract, nodeContract;
  let injectedWeb3 = null;
  const infura_key = 'c3e254116c559ae5e58746e69fb38787';

  const show = ref(false)
  const showPopover = ref(false)
  const address = ref(sessionStorage.getItem('address') || '')
  const emits = defineEmits(['getSigner'])
  const pAddr = ref('')
  const route = useRoute()

  onMounted(() => {
    init()
  })

  const element = document.querySelector('.header')

  const actions = [
      { text: '中文' },
      { text: 'English' },
      { text: '日本語' },
      { text: '한국인' }
    ];

  async function init() {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          bridge: "https://uniswap.bridge.walletconnect.org",
          rpc: {
            56: 'https://bsc-dataseed.binance.org/',
            66: 'https://exchainrpc.okex.org',
            97: 'https://data-seed-prebsc-1-s3.binance.org:8545/',
            137: 'https://polygon-rpc.com/',
          },
          // Mikko's test key - don't copy as your mileage may vary
          infuraId: infura_key,
        }
      },
    };
    web3Modal = new Web3Modal({
      cacheProvider: false, // optional
      providerOptions, // required
      disableInjectedProvider: false, // optional. For MetaMask / Brave / Opera.
    });
    try {
      provider = await web3Modal.connect();
      provider.enable()
    } catch (e) {
      console.log("Could not get a wallet connection", e);
      alert("cannot connect wallet");
      return;
    }
    // Subscribe to accounts change
    provider.on("accountsChanged", async (accounts) => {
      await fetchAccountData();
    });
    // Subscribe to chainId change
    provider.on("chainChanged", async (chainId) => {
      await fetchAccountData();
    });
    // Subscribe to networkId change
    provider.on("networkChanged", async (networkId) => {
      await fetchAccountData();
    });
    provider.on("disconnect", async (code, reason) => {
      console.log(code, reason);
      await onDisconnect();
    });
    await fetchAccountData(provider);
  }

  async function fetchAccountData() {
    const web3 = new Web3(provider);
    injectedWeb3 = web3;
    const accounts = await web3.eth.getAccounts();
    selectedAccount = accounts[0];
    network = await web3.eth.net.getId();
    console.log(network + ': ' + selectedAccount);
    if (network != 56) {
      showToast('请使用币安智能链')
      await onDisconnect();
    } else {
      provider1 = new ethers.providers.Web3Provider(web3.currentProvider);
      signer = provider1.getSigner();
      if(sessionStorage.getItem('signature')) {
        address.value = selectedAccount;
        gasPrice = await web3.eth.getGasPrice();
        usdtContract = new ethers.Contract(contractConfig.usdtAddress, usdtAbi, signer);
        conContract = new ethers.Contract(contractConfig.conAddress, conAbi, signer);
        nodeContract = new ethers.Contract(contractConfig.nodeAddress, nodeAbi, signer);
        toContinue()
      } else {
        try{
          const signature = await signer.signMessage('Link Wallet')
          if(signature) {
            sessionStorage.setItem('signature', '1')
            address.value = selectedAccount;
            gasPrice = await web3.eth.getGasPrice();
            usdtContract = new ethers.Contract(contractConfig.usdtAddress, usdtAbi, signer);
            conContract = new ethers.Contract(contractConfig.conAddress, conAbi, signer);
            nodeContract = new ethers.Contract(contractConfig.nodeAddress, nodeAbi, signer);
            sessionStorage.setItem('address', selectedAccount)
            toContinue()
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  }

  async function toContinue() {
    emits('getSigner', {
      address: address.value,
      nodeContract,
      usdtContract,
      conContract,
      gasPrice
    })
    if(route.query.p_address) {
      pAddr.value = route.query.p_address
    }
    const addr = await conContract.getReferrer(address.value)
    if(addr === '0x0000000000000000000000000000000000000000' && address.value !== '0x9ae7ABc35b2d23b936780D24fd3977e645C09D2C') {
      show.value = true
    }
  }

  async function handleBind() {
     if(pAddr.value === '') {
      showToast('请输入上级地址')
      return
    }
    if(pAddr.value.substring(0, 2) !== '0x' || pAddr.value.length !== 42) {
      showToast('请输入正确的钱包地址')
      return
    }
    showLoadingToast({
      message: '等待链上确认',
      forbidClick: true,
      duration: 0
    })
    try {
      const res = await conContract.bindReferrer(pAddr.value)
      if(res) {
        showSuccessToast('已绑定')
        show.value = false
      } else {
        console.log(res)
      }
    } catch (e) {
      showFailToast('操作失败')
    }
  }

  async function onDisconnect() {
    console.log("Killing the wallet connection", provider);
    // TODO: Which providers have close method?
    if (address.value) {
      await web3Modal.clearCachedProvider();
      await provider.disconnect()
      provider = null;
      selectedAccount = null;
      address.value = '';
    }
  }
</script>

<style scoped lang="less">
.header{
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  height: 54px;
  background: #111111;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  border-bottom: 0.5px solid #414141;
  z-index: 99;

  .left{
    display: flex;
    align-items: center;

    .logo{
      width: 33px;
      margin-right: 2px;
    }
    .text{
      font-size: 13px;
      font-weight: bold;
    }
  }
  .right{
    display: flex;

    .lang{
      height: 33px;
      background: #262A22;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .icon{
        width: 16px;
      }
      .arrow{
        width: 9px;
        margin-left: 4px;
      }
    }
    .wallet{
      height: 33px;
      background: #262A22;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      margin-left: 6px;

      .icon{
        width: 19px;
        margin-right: 6px;
      }
      .text{
        font-size: 13px;
      }
    }
  }
}
.block{
  height: 54px;
}
.bind{
  width: 309px;
  height: 235px;
  background: url("@/assets/img/bindBg.png") no-repeat;
  background-size: 100% 100%;
  padding: 24px 22px 0 22px;

  .title{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    line-height: 24px;
    margin-bottom: 32px;
  }
  .btn{
    width: 115px;
    height: 35px;
    margin: 28px auto 0 auto;
  }
}
.van-popup{
  background: transparent;
}
:deep(.van-popover--dark){
  .van-popover__content{
    background: #262A22;
  }
  .van-popover__action{
    width: 100px;
    height: 36px;
  }
  .van-popover__action:active{
    background-color: transparent;
    color: #B9EC66;
  }
}
</style>
